import React, { useState, useEffect } from 'react';
import './Mobileview.css';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  BsHouse,
  BsInfoCircle,
  BsBriefcase,
  BsFolderCheck,
  BsNewspaper,
  BsEnvelope,
  BsShieldCheck,
  BsArrowRight,
  BsCpu,
  BsRobot,
  BsCodeSquare,
  BsGlobe,
  BsGraphUpArrow,
  BsPalette,
  BsLayers,
  BsXLg,
  BsChevronDown
} from 'react-icons/bs';

const Mobileview = ({ setshow }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [openSection, setOpenSection] = useState({
    services: false,
    products: false
  });

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  const handleNav = (path) => {
    setshow(false);
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const toggleSection = (section) => {
    setOpenSection(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const isServicesActive = () => {
    return (
      location.pathname === '/services' ||
      location.pathname === '/crm-development' ||
      location.pathname === '/erp-development' ||
      location.pathname === '/ai-automation' ||
      location.pathname === '/software-development' ||
      location.pathname === '/web-development' ||
      location.pathname === '/digital-marketing' ||
      location.pathname === '/ui-ux-design' ||
      location.pathname.startsWith('/solutions/')
    );
  };

  return (
    <div className="mobile-drawer-overlay fixed inset-0 z-[9999] flex justify-end bg-black/70 backdrop-blur-sm">
      {/* Backdrop area - click to close */}
      <div 
        className="flex-1 cursor-pointer" 
        onClick={() => setshow(false)} 
        aria-label="Close menu background"
      />

      {/* Drawer Container */}
      <div className="mobile-drawer w-full max-w-[340px] sm:max-w-[360px] h-full h-[100dvh] bg-[#080c14] border-l border-slate-800/90 text-slate-100 flex flex-col shadow-2xl relative">
        
        {/* Drawer Header */}
        <div className="flex items-center justify-between p-4 px-5 border-b border-slate-800/80 bg-[#080c14]/95 shrink-0">
          <div 
            className="flex items-center gap-2.5 cursor-pointer group"
            onClick={() => handleNav('/')}
          >
            <img 
              src="/logo.png" 
              alt="Beta Communes" 
              className="h-8 w-auto object-contain transition-transform group-hover:scale-105" 
            />
            <div className="flex flex-col">
              <span className="text-sm font-extrabold tracking-tight text-white leading-none">
                Beta Communes
              </span>
              <span className="text-[10px] font-medium tracking-wide text-slate-400 mt-0.5">
                Build · Grow · Together
              </span>
            </div>
          </div>

          <button
            onClick={() => setshow(false)}
            aria-label="Close navigation menu"
            className="w-8 h-8 rounded-full bg-slate-900 border border-slate-800 text-slate-300 hover:text-white hover:border-[#f06600] flex items-center justify-center transition-all cursor-pointer"
          >
            <BsXLg className="text-xs" />
          </button>
        </div>

        {/* Scrollable Navigation Body */}
        <div className="flex-1 overflow-y-auto px-4 py-4 space-y-2 custom-scrollbar">
          
          {/* Main Navigation List */}
          <div className="space-y-1">
            
            {/* Home */}
            <div
              onClick={() => handleNav('/')}
              className={`flex items-center justify-between px-3.5 py-2.5 rounded-xl cursor-pointer transition-all ${
                isActive('/') && location.pathname === '/'
                  ? 'bg-orange-500/15 text-[#f06600] font-bold border-l-2 border-[#f06600]'
                  : 'text-slate-300 hover:text-white hover:bg-slate-900/60'
              }`}
            >
              <div className="flex items-center gap-3">
                <BsHouse className="text-base text-[#f06600]" />
                <span className="text-sm">Home</span>
              </div>
              {isActive('/') && location.pathname === '/' && (
                <span className="w-1.5 h-1.5 rounded-full bg-[#f06600]" />
              )}
            </div>

            {/* About */}
            <div
              onClick={() => handleNav('/aboutus')}
              className={`flex items-center justify-between px-3.5 py-2.5 rounded-xl cursor-pointer transition-all ${
                isActive('/aboutus')
                  ? 'bg-orange-500/15 text-[#f06600] font-bold border-l-2 border-[#f06600]'
                  : 'text-slate-300 hover:text-white hover:bg-slate-900/60'
              }`}
            >
              <div className="flex items-center gap-3">
                <BsInfoCircle className="text-base text-[#f06600]" />
                <span className="text-sm">About</span>
              </div>
              {isActive('/aboutus') && (
                <span className="w-1.5 h-1.5 rounded-full bg-[#f06600]" />
              )}
            </div>

            {/* Services (with Accordion to dedicated solutions) */}
            <div className="rounded-xl overflow-hidden">
              <div className="flex items-center justify-between">
                <div
                  onClick={() => handleNav('/services')}
                  className={`flex-1 flex items-center gap-3 px-3.5 py-2.5 rounded-l-xl cursor-pointer transition-all ${
                    isServicesActive()
                      ? 'bg-orange-500/15 text-[#f06600] font-bold border-l-2 border-[#f06600]'
                      : 'text-slate-300 hover:text-white hover:bg-slate-900/60'
                  }`}
                >
                  <BsBriefcase className="text-base text-[#f06600]" />
                  <span className="text-sm">Services</span>
                </div>
                <button
                  onClick={() => toggleSection('services')}
                  aria-label="Toggle services list"
                  className="px-3 py-2.5 text-slate-400 hover:text-white hover:bg-slate-900/80 rounded-r-xl transition-all cursor-pointer"
                >
                  <BsChevronDown
                    className={`text-xs transition-transform duration-300 ${
                      openSection.services ? 'rotate-180 text-[#f06600]' : ''
                    }`}
                  />
                </button>
              </div>

              {/* Collapsible Solutions Sub-links */}
              {openSection.services && (
                <div className="mt-1 ml-4 pl-3 border-l border-slate-800/80 space-y-0.5 text-xs font-medium">
                  <div
                    onClick={() => handleNav('/crm-development')}
                    className={`p-2 px-3 rounded-lg flex items-center gap-2.5 cursor-pointer transition-all ${
                      location.pathname === '/crm-development'
                        ? 'text-[#f06600] font-bold bg-orange-500/10'
                        : 'text-slate-400 hover:text-slate-200 hover:bg-slate-900/60'
                    }`}
                  >
                    <BsBriefcase className="text-xs text-[#f06600]" />
                    <span>CRM Development</span>
                  </div>
                  <div
                    onClick={() => handleNav('/erp-development')}
                    className={`p-2 px-3 rounded-lg flex items-center gap-2.5 cursor-pointer transition-all ${
                      location.pathname === '/erp-development'
                        ? 'text-[#f06600] font-bold bg-orange-500/10'
                        : 'text-slate-400 hover:text-slate-200 hover:bg-slate-900/60'
                    }`}
                  >
                    <BsCpu className="text-xs text-[#f06600]" />
                    <span>ERP Development</span>
                  </div>
                  <div
                    onClick={() => handleNav('/ai-automation')}
                    className={`p-2 px-3 rounded-lg flex items-center gap-2.5 cursor-pointer transition-all ${
                      location.pathname === '/ai-automation'
                        ? 'text-[#f06600] font-bold bg-orange-500/10'
                        : 'text-slate-400 hover:text-slate-200 hover:bg-slate-900/60'
                    }`}
                  >
                    <BsRobot className="text-xs text-[#f06600]" />
                    <span>AI & Automation</span>
                  </div>
                  <div
                    onClick={() => handleNav('/software-development')}
                    className={`p-2 px-3 rounded-lg flex items-center gap-2.5 cursor-pointer transition-all ${
                      location.pathname === '/software-development'
                        ? 'text-[#f06600] font-bold bg-orange-500/10'
                        : 'text-slate-400 hover:text-slate-200 hover:bg-slate-900/60'
                    }`}
                  >
                    <BsCodeSquare className="text-xs text-[#f06600]" />
                    <span>Custom Software</span>
                  </div>
                  <div
                    onClick={() => handleNav('/web-development')}
                    className={`p-2 px-3 rounded-lg flex items-center gap-2.5 cursor-pointer transition-all ${
                      location.pathname === '/web-development'
                        ? 'text-[#f06600] font-bold bg-orange-500/10'
                        : 'text-slate-400 hover:text-slate-200 hover:bg-slate-900/60'
                    }`}
                  >
                    <BsGlobe className="text-xs text-[#f06600]" />
                    <span>Web Development</span>
                  </div>
                  <div
                    onClick={() => handleNav('/digital-marketing')}
                    className={`p-2 px-3 rounded-lg flex items-center gap-2.5 cursor-pointer transition-all ${
                      location.pathname === '/digital-marketing'
                        ? 'text-[#f06600] font-bold bg-orange-500/10'
                        : 'text-slate-400 hover:text-slate-200 hover:bg-slate-900/60'
                    }`}
                  >
                    <BsGraphUpArrow className="text-xs text-[#f06600]" />
                    <span>Digital Marketing</span>
                  </div>
                  <div
                    onClick={() => handleNav('/ui-ux-design')}
                    className={`p-2 px-3 rounded-lg flex items-center gap-2.5 cursor-pointer transition-all ${
                      location.pathname === '/ui-ux-design'
                        ? 'text-[#f06600] font-bold bg-orange-500/10'
                        : 'text-slate-400 hover:text-slate-200 hover:bg-slate-900/60'
                    }`}
                  >
                    <BsPalette className="text-xs text-[#f06600]" />
                    <span>UI/UX Design</span>
                  </div>
                </div>
              )}
            </div>

            {/* Products (with Accordion) */}
            <div className="rounded-xl overflow-hidden">
              <div className="flex items-center justify-between">
                <div
                  onClick={() => handleNav('/products')}
                  className={`flex-1 flex items-center gap-3 px-3.5 py-2.5 rounded-l-xl cursor-pointer transition-all ${
                    isActive('/products')
                      ? 'bg-orange-500/15 text-[#f06600] font-bold border-l-2 border-[#f06600]'
                      : 'text-slate-300 hover:text-white hover:bg-slate-900/60'
                  }`}
                >
                  <BsLayers className="text-base text-[#f06600]" />
                  <span className="text-sm">Products</span>
                </div>
                <button
                  onClick={() => toggleSection('products')}
                  aria-label="Toggle products list"
                  className="px-3 py-2.5 text-slate-400 hover:text-white hover:bg-slate-900/80 rounded-r-xl transition-all cursor-pointer"
                >
                  <BsChevronDown
                    className={`text-xs transition-transform duration-300 ${
                      openSection.products ? 'rotate-180 text-[#f06600]' : ''
                    }`}
                  />
                </button>
              </div>

              {/* Collapsible Products Sub-links */}
              {openSection.products && (
                <div className="mt-1 ml-4 pl-3 border-l border-slate-800/80 space-y-1 text-xs font-medium">
                  <div
                    onClick={() => handleNav('/products')}
                    className="p-2 px-3 rounded-lg flex items-center gap-2.5 text-slate-400 hover:text-slate-200 hover:bg-slate-900/60 cursor-pointer transition-all"
                  >
                    <span className="w-5 h-5 rounded bg-[#f06600] text-white flex items-center justify-center text-[9px] font-bold">
                      BC
                    </span>
                    <span>Beta CRM Platform</span>
                  </div>
                  <div
                    onClick={() => handleNav('/products')}
                    className="p-2 px-3 rounded-lg flex items-center gap-2.5 text-slate-400 hover:text-slate-200 hover:bg-slate-900/60 cursor-pointer transition-all"
                  >
                    <span className="w-5 h-5 rounded bg-slate-800 border border-slate-700 text-white flex items-center justify-center text-[9px] font-bold">
                      BE
                    </span>
                    <span>Beta ERP Core</span>
                  </div>
                  <div
                    onClick={() => handleNav('/products')}
                    className="p-2 px-3 rounded-lg flex items-center gap-2.5 text-slate-400 hover:text-slate-200 hover:bg-slate-900/60 cursor-pointer transition-all"
                  >
                    <span className="w-5 h-5 rounded bg-emerald-600 text-white flex items-center justify-center text-[9px] font-bold">
                      WA
                    </span>
                    <span>WhatsApp AI Bot</span>
                  </div>
                </div>
              )}
            </div>

            {/* Work */}
            <div
              onClick={() => handleNav('/portfolio')}
              className={`flex items-center justify-between px-3.5 py-2.5 rounded-xl cursor-pointer transition-all ${
                isActive('/portfolio')
                  ? 'bg-orange-500/15 text-[#f06600] font-bold border-l-2 border-[#f06600]'
                  : 'text-slate-300 hover:text-white hover:bg-slate-900/60'
              }`}
            >
              <div className="flex items-center gap-3">
                <BsFolderCheck className="text-base text-[#f06600]" />
                <span className="text-sm">Work</span>
              </div>
              {isActive('/portfolio') && (
                <span className="w-1.5 h-1.5 rounded-full bg-[#f06600]" />
              )}
            </div>

            {/* Insights */}
            <div
              onClick={() => handleNav('/blog')}
              className={`flex items-center justify-between px-3.5 py-2.5 rounded-xl cursor-pointer transition-all ${
                isActive('/blog')
                  ? 'bg-orange-500/15 text-[#f06600] font-bold border-l-2 border-[#f06600]'
                  : 'text-slate-300 hover:text-white hover:bg-slate-900/60'
              }`}
            >
              <div className="flex items-center gap-3">
                <BsNewspaper className="text-base text-[#f06600]" />
                <span className="text-sm">Insights</span>
              </div>
              {isActive('/blog') && (
                <span className="w-1.5 h-1.5 rounded-full bg-[#f06600]" />
              )}
            </div>

            {/* Contact */}
            <div
              onClick={() => handleNav('/contactus')}
              className={`flex items-center justify-between px-3.5 py-2.5 rounded-xl cursor-pointer transition-all ${
                isActive('/contactus')
                  ? 'bg-orange-500/15 text-[#f06600] font-bold border-l-2 border-[#f06600]'
                  : 'text-slate-300 hover:text-white hover:bg-slate-900/60'
              }`}
            >
              <div className="flex items-center gap-3">
                <BsEnvelope className="text-base text-[#f06600]" />
                <span className="text-sm">Contact</span>
              </div>
              {isActive('/contactus') && (
                <span className="w-1.5 h-1.5 rounded-full bg-[#f06600]" />
              )}
            </div>

          </div>

          {/* Portal Access Card */}
          <div className="pt-2">
            <div
              onClick={() => handleNav('/portal/login')}
              className="p-3 px-3.5 rounded-xl bg-slate-900/80 border border-slate-800 hover:border-[#f06600]/60 flex items-center justify-between cursor-pointer group transition-all"
            >
              <div className="flex items-center gap-2.5">
                <div className="w-7 h-7 rounded-lg bg-orange-500/10 text-[#f06600] flex items-center justify-center text-sm group-hover:scale-105 transition-transform">
                  <BsShieldCheck />
                </div>
                <div>
                  <div className="text-xs font-bold text-white group-hover:text-[#f06600] transition-colors">
                    Beta Portal
                  </div>
                  <div className="text-[10px] text-slate-400">
                    Client &amp; Team Login
                  </div>
                </div>
              </div>
              <BsArrowRight className="text-xs text-slate-500 group-hover:text-[#f06600] group-hover:translate-x-0.5 transition-all" />
            </div>
          </div>

        </div>

        {/* Drawer Footer CTA */}
        <div className="p-4 px-5 border-t border-slate-800/80 bg-[#080c14] shrink-0 space-y-3">
          <button
            onClick={() => handleNav('/contactus')}
            className="w-full bg-[#f06600] hover:bg-[#d05800] text-white py-3 px-4 rounded-xl font-bold text-sm flex items-center justify-center gap-2 shadow-lg shadow-orange-500/20 hover:shadow-orange-500/30 transition-all cursor-pointer"
          >
            <span>Let's Talk</span>
            <BsArrowRight className="text-sm" />
          </button>

          <div className="flex items-center justify-between text-[11px] text-slate-400 pt-1">
            <span>Have an idea?</span>
            <span 
              onClick={() => handleNav('/contactus')}
              className="text-[#f06600] hover:underline cursor-pointer font-medium"
            >
              Get free consultation →
            </span>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Mobileview;